import { render, staticRenderFns } from "./dealerDownload.vue?vue&type=template&id=85c8b996"
import script from "./dealerDownload.vue?vue&type=script&lang=js"
export * from "./dealerDownload.vue?vue&type=script&lang=js"
import style0 from "./dealerDownload.vue?vue&type=style&index=0&id=85c8b996&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonImg: require('/root/workspace/web-company_Yo6Q/components/common/commonImg.vue').default})
